import type { SelectionState } from '@/store';

export function getOrderedSelectionStates (selectionStateHistory: Record<string, SelectionState>): SelectionState[] {
	const activeStates: SelectionState[] = Object.keys(selectionStateHistory || {}).reduce((arr, key) => {
		const selectionState: SelectionState = selectionStateHistory[key];
		if (selectionState && selectionState.sortOrder) {
			arr.push(selectionState);
		}
		return arr;
	}, [] as SelectionState[]);

	return [...activeStates].sort((a, b) => a.sortOrder - b.sortOrder);
}

export function getCurrentSelectionStateFromHistory (
	selectionStateHistory: Record<string, SelectionState>,
	emptySelectionState: SelectionState,
): SelectionState {
	const orderedStates = getOrderedSelectionStates(selectionStateHistory);
	return orderedStates.length ? { ...orderedStates[orderedStates.length - 1] } : emptySelectionState;
}

export function getSelectionStateByTriggerFromHistory (
	selectionStateHistory: Record<string, SelectionState>,
	triggeringId: string,
	emptySelectionState: SelectionState,
): SelectionState {
	return selectionStateHistory?.[triggeringId] || emptySelectionState;
}
